<template>
  <transition name="notification" appear>
    <div
      class="notification"
      @click.stop
      @mouseenter="clearTime"
      @mouseleave="updateTime"
    >
      <div class="text-block">
        <p class="text text-body-m-book">
          {{
            deleteCard ? notificationData.deleteText : notificationData.addText
          }}
        </p>
        <p class="counter-text text-body-s-book">
          Товаров из категории — {{ categoryCount || 0 }}
        </p>
      </div>
      <UiUiButton
        :mode="deleteCard ? 'button' : 'link'"
        :path="notificationData.link"
        class="button"
        @click="cancelDeleteCard"
      >
        {{
          deleteCard
            ? notificationData.deleteButton
            : notificationData.addButton
        }}
      </UiUiButton>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue';
import { useCompareStore } from '~/stores/compare';
import { useFavoriteStore } from '~/stores/favorite';
import { useModalsStore } from '~/stores/modals';

const props = defineProps({
  type: {
    type: String,
    required: true,
    validator: (v: string) => ['favorite', 'compare'].includes(v),
  },
  categoryCount: {
    type: Number,
    default: 0,
  },
  deleteCard: Boolean,
  date: Number,
  id: [Number, String],
  catId: Number,
});

const emit = defineEmits(['close']);

const favoriteStore = useFavoriteStore();
const compareStore = useCompareStore();
const modalsStore = useModalsStore();

const timerId = ref<number>();

function close() {
  emit('close');
}

function clearTime() {
  if (timerId.value) {
    clearTimeout(timerId.value);
  }
}

function updateTime() {
  clearTime();
  timerId.value = window.setTimeout(() => close(), 3000);
}

watch(
  () => props.date,
  () => {
    clearTime();
    timerId.value = window.setTimeout(() => close(), 5000);
  },
  { immediate: true }
);

const notificationData = computed(() => {
  if (props.type === 'favorite') {
    return {
      deleteText: 'Товар удален из избранного',
      addText: 'Товар добавлен в избранное',
      deleteButton: 'Отменить',
      addButton: 'Посмотреть',
      link: '/favorite/',
    };
  }
  return {
    deleteText: 'Товар удален из сравнения',
    addText: 'Товар добавлен к сравнению',
    deleteButton: 'Вернуть',
    addButton: 'Сравнить',
    link: '/compare/',
  };
});

function cancelDeleteCard() {
  close();
  if (props.deleteCard) {
    if (props.type === 'favorite') {
      favoriteStore.toggleFavorite({
        id: props.id,
        catId: props.catId,
        deleteCard: favoriteStore.ids.includes(props.id),
      });
    }
    if (props.type === 'compare') {
      compareStore.toggleCompare({
        id: props.id,
        catId: props.catId,
        deleteCard: compareStore.ids.includes(props.id),
      });
    }
  } else {
    modalsStore.close('quickView');
    window.scrollTo(0, 0);
  }
}
</script>

<style scoped lang="scss" src="./notification.scss" />
